module.exports = __webpack_public_path__ + "img/title-web.8bcc2374.png";